import axios from 'axios';
import { API_BASE_URL } from '../config';

export interface NotificationTemplate {
  _id: string;
  name: string;
  type: 'SYSTEM' | 'PROMOTIONAL' | 'TRANSACTIONAL' | 'EVENT';
  title: string;
  body: string;
  metadata?: Record<string, any>;
}

const API_URL = `${API_BASE_URL}/api/notification-templates`;

// Helper to get auth config (HttpOnly cookies are sent automatically)
const getAuthConfig = () => {
  return {
    withCredentials: true, // Required to send HttpOnly cookies
  };
};

export const notificationTemplateService = {
  // Get all templates
  async getTemplates() {
    const response = await axios.get<NotificationTemplate[]>(API_URL, getAuthConfig());
    return response.data;
  },

  // Create new template
  async createTemplate(template: Omit<NotificationTemplate, '_id'>) {
    const response = await axios.post<NotificationTemplate>(API_URL, template, getAuthConfig());
    return response.data;
  },

  // Update template
  async updateTemplate(id: string, template: Partial<NotificationTemplate>) {
    const response = await axios.put<NotificationTemplate>(`${API_URL}/${id}`, template, getAuthConfig());
    return response.data;
  },

  // Delete template
  async deleteTemplate(id: string) {
    const response = await axios.delete(`${API_URL}/${id}`, getAuthConfig());
    return response.data;
  },

  // Get template change logs
  async getTemplateLogs() {
    const response = await axios.get(`${API_URL}/logs`, getAuthConfig());
    return response.data;
  }
}; 